import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  HostListener,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import * as $ from "jquery";
import { SearchQueryModel } from "../../models/query.model";
import { SearchModel } from "../../models/search-model";

@Component({
  selector: "app-advanced-search-entities",
  templateUrl: "./advanced-search-entities.component.html",
  styleUrls: ["./advanced-search-entities.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AdvancedSearchEntitiesComponent implements OnInit {
  @Input() advSearchModel: SearchModel;
  @Input() id: string;

  @Output() search = new EventEmitter<SearchQueryModel>();

  isAdvanced: boolean;
  inputArray: any[];
  advForm: FormGroup;
  optionArray = {};
  filter = "";
  basicSearchQuery = "";

  constructor() {
    this.isAdvanced = false;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent): void {
    this.isAdvanced = false;
  }

  ngOnInit() {
    this.advForm = this.advSearchModel.form;
    this.inputArray = Object.entries(this.advSearchModel.dataType).map(
      (e: any) => e.flatMap((f) => f)
    );
    this.extractOptions();
    $(document).mouseup((ev) => {
      const container = $(`#${this.id}`);
      const calendar = $("mat-calendar");
      const matOption = $("mat-option");
      const backdrop = $(".cdk-overlay-backdrop");
      if (
        !matOption.is(ev.target) &&
        !calendar.is(ev.target) &&
        !container.is(ev.target) &&
        !backdrop.is(ev.target) &&
        matOption.has(ev.target).length === 0 &&
        container.has(ev.target).length === 0 &&
        calendar.has(ev.target).length === 0 &&
        backdrop.has(ev.target).length === 0
      ) {
        container.hide("fast", "swing", (c) => {
          this.isAdvanced = false;
        });
      }
    });
  }

  extractOptions = (fieldName?, fieldValue?) =>
    this.inputArray
      .filter((x) => x[1] === "select" || x[1] === "selectEntity")
      .filter((x) => (fieldName ? x[0] === fieldName : true))
      .forEach((x) => {
        const options = x[2]
          .flatMap((e) => e)
          .filter((e) =>
            fieldValue
              ? e.toLowerCase().includes(fieldValue.toLowerCase())
              : true
          );
        this.optionArray[x[0]] = options;
      });

  searchToggle() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  reset() {
    this.advForm.reset();
  }

  optionSearchFilter(query) {
    const fieldName = query.target.parentNode.parentNode.id;
    this.extractOptions(fieldName, query.target.value);
  }

  queryBuilder() {
    if (
      this.isNotNullOrEmpty(this.advForm.value.keyword) ||
      this.isNotNullOrEmpty(this.advForm.value.code) ||
      this.isNotNullOrEmpty(this.advForm.value.name) ||
      this.isNotNullOrEmpty(this.advForm.value.type) ||
      this.isNotNullOrEmpty(this.advForm.value.status) ||
      this.isNotNullOrEmpty(
        this.advForm.value.modifiedDate.from?.toISOString()
      ) ||
      this.isNotNullOrEmpty(this.advForm.value.modifiedDate.to?.toISOString())
    ) {
      const query = {
        searchQuery: {
          keyword: this.advForm.value.keyword,
          code: this.advForm.value.code,
          name: this.advForm.value.name,
          type: this.advForm.value.type,
          status: this.advForm.value.status,
          phone: this.advForm.value.phone,
          email: this.advForm.value.email,
          updated_date_from:
            this.advForm.value.modifiedDate.from?.toISOString(),
          updated_date_to: this.advForm.value.modifiedDate.to?.toISOString(),
        },
        isEmpty: false,
        table: this.advSearchModel.table,
      };
      return query;
    } else {
      const query = {
        searchQuery: {
          keyword: this.advForm.value.keyword,
          code: this.advForm.value.code,
          name: this.advForm.value.name,
          type: this.advForm.value.type,
          status: this.advForm.value.status,
          phone: this.advForm.value.phone,
          email: this.advForm.value.email,
          updated_date_from:
            this.advForm.value.modifiedDate.from?.toISOString(),
          updated_date_to: this.advForm.value.modifiedDate.to?.toISOString(),
        },
        isEmpty: true,
        table: this.advSearchModel.table,
      };
      return query;
    }
  }

  basicSearch(e: string) {
    if (this.isNotNullOrEmpty(e)) {
      const query = {
        searchQuery: {
          keyword: e,
        },
        isEmpty: false,
        table: this.advSearchModel.table,
      };
      this.search.emit(query);
    } else {
      const query = {
        searchQuery: {
          keyword: e,
        },
        isEmpty: true,
        table: this.advSearchModel.table,
      };
      this.search.emit(query);
    }
  }

  advancedSearch() {
    const container = $(`#${this.id}`);
    const query = this.queryBuilder();
    this.search.emit(query);
    container.hide("fast", "swing", (c) => {
      this.isAdvanced = false;
    });
  }

  isNotNullOrEmpty(input: string | null | undefined): boolean {
    return input !== null && input !== undefined && input.trim() !== "";
  }
}
